<script setup>
import { FOLDER_NAME_MAX_LENGTH } from 'dashboard/composables/useTemplateFolders';

defineProps({
  name: {
    type: String,
    default: '',
  },
  error: {
    type: String,
    default: '',
  },
  isSaving: {
    type: Boolean,
    default: false,
  },
  nameLabel: {
    type: String,
    default: '',
  },
  saveLabel: {
    type: String,
    default: '',
  },
  cancelLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:name', 'save', 'cancel']);

const onSubmit = () => {
  emit('save');
};
</script>

<template>
  <form
    class="flex flex-col gap-2 rounded-xl bg-n-alpha-2 p-3"
    data-testid="template-folder-form"
    @submit.prevent="onSubmit"
  >
    <label
      for="template-folder-name"
      class="text-xs font-medium text-n-slate-12"
    >
      {{ nameLabel }}
    </label>
    <input
      id="template-folder-name"
      data-testid="template-folder-name"
      type="text"
      :value="name"
      :maxlength="FOLDER_NAME_MAX_LENGTH"
      :disabled="isSaving"
      :aria-invalid="error ? 'true' : 'false'"
      :aria-describedby="error ? 'template-folder-name-error' : undefined"
      class="reset-base w-full min-w-0 h-9 px-2.5 rounded-xl bg-n-background text-n-slate-12 !text-sm outline outline-1 outline-n-weak focus:outline-n-brand"
      @input="emit('update:name', $event.target.value)"
    />
    <p
      v-if="error"
      id="template-folder-name-error"
      class="text-xs text-n-ruby-9"
      data-testid="template-folder-form-error"
    >
      {{ error }}
    </p>
    <div class="flex flex-wrap gap-2">
      <button
        type="button"
        data-testid="template-folder-save"
        :disabled="isSaving"
        class="inline-flex items-center justify-center min-h-10 px-3 text-xs font-medium rounded-full bg-n-slate-12 text-n-solid-1 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-n-brand"
        @click="onSubmit"
      >
        {{ saveLabel }}
      </button>
      <button
        type="button"
        data-testid="template-folder-cancel"
        :disabled="isSaving"
        class="inline-flex items-center justify-center min-h-10 px-3 text-xs font-medium rounded-full bg-n-alpha-2 text-n-slate-12 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-n-brand"
        @click="emit('cancel')"
      >
        {{ cancelLabel }}
      </button>
    </div>
  </form>
</template>
